import React, { useEffect, useState, useRef } from 'react';
const NAMES = ['María', 'Lucía', 'Sofía', 'Valentina', 'Camila', 'Martina', 'Florencia', 'Agustina', 'Daniela', 'Carolina', 'Laura', 'Patricia', 'Romina', 'Gabriela', 'Mariela', 'Cecilia', 'Verónica', 'Andrea', 'Silvia', 'Natalia'];
const LAST_INITIALS = ['G.', 'P.', 'M.', 'R.', 'L.', 'S.', 'T.', 'V.', 'F.', 'C.'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Tucumán', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Resistencia', 'Neuquén', 'Posadas', 'Bahía Blanca', 'Paraná', 'Formosa', 'San Luis', 'Catamarca', 'Río Gallegos', 'Ushuaia', 'Comodoro Rivadavia', 'San Miguel de Tucumán'];
const VISIBLE_MS = 5000;
const INTERVAL_MS = 30000; // Show a new popup every 30 seconds
function pick<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [hasMounted, setHasMounted] = useState(false);
  const [data, setData] = useState({
    name: '',
    initial: '',
    city: '',
    time: 0
  });
  const hideTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const showTimerRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const firstTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => {
    // Defer mounting work to idle time so the popup doesn't slow initial render.
    const showPopup = () => {
      setData({
        name: pick(NAMES),
        initial: pick(LAST_INITIALS),
        city: pick(CITIES),
        time: Math.floor(Math.random() * 59) + 1
      });
      setIsVisible(true);
      if (hideTimerRef.current) clearTimeout(hideTimerRef.current);
      hideTimerRef.current = setTimeout(() => setIsVisible(false), VISIBLE_MS);
    };
    // First popup after 8s, then every 30s
    firstTimerRef.current = setTimeout(() => {
      setHasMounted(true);
      showPopup();
      showTimerRef.current = setInterval(showPopup, INTERVAL_MS);
    }, 8000);
    return () => {
      if (firstTimerRef.current) clearTimeout(firstTimerRef.current);
      if (hideTimerRef.current) clearTimeout(hideTimerRef.current);
      if (showTimerRef.current) clearInterval(showTimerRef.current);
    };
  }, []);
  if (!hasMounted) return null;
  return <div role="status" aria-live="polite" className={['fixed bottom-4 left-4 z-50 max-w-[320px] w-[calc(100%-2rem)]', 'bg-white rounded-xl shadow-2xl border border-gray-100 p-3 sm:p-4', 'flex gap-3 items-start', 'transition-all duration-300 ease-out will-change-transform', isVisible ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-6 pointer-events-none'].join(' ')} data-id="element-175">
      <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 transition-colors w-5 h-5 flex items-center justify-center" aria-label="Cerrar" data-id="element-176">
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-177">
          <line x1="18" y1="6" x2="6" y2="18" data-id="element-178" />
          <line x1="6" y1="6" x2="18" y2="18" data-id="element-179" />
        </svg>
      </button>

      <div className="relative shrink-0" data-id="element-180">
        <div className="w-10 h-10 rounded-full bg-blue-100 text-blue-700 font-bold flex items-center justify-center text-sm" data-id="element-181">
          {data.name.charAt(0)}
          {data.initial.charAt(0)}
        </div>
        <div className="absolute -bottom-1 -right-1 w-3.5 h-3.5 bg-green-500 rounded-full border-2 border-white animate-pulse" data-id="element-182" />
      </div>

      <div className="flex-1 pr-4" data-id="element-183">
        <p className="text-sm text-gray-800 leading-tight mb-1" data-id="element-184">
          <span className="font-bold" data-id="element-185">
            {data.name} {data.initial}
          </span>{' '}
          de {data.city} acaba de comprar el{' '}
          <span className="font-semibold text-blue-600" data-id="element-186">
            Pack de Inglés 360
          </span>
        </p>
        <div className="flex items-center gap-1.5 text-xs text-gray-500" data-id="element-187">
          <span className="flex items-center gap-1 text-green-600 font-medium" data-id="element-188">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-189">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" data-id="element-190" />
              <polyline points="22 4 12 14.01 9 11.01" data-id="element-191" />
            </svg>
            Compra verificada
          </span>
          <span data-id="element-192">•</span>
          <span data-id="element-193">hace {data.time} min</span>
        </div>
      </div>
    </div>;
}